<template>
  <div class="outer" @click="onClick" v-loading="loading">
    <el-button>上传文件</el-button>
    <input type="file" ref="uploadFile" @change="onChange" />
  </div>
</template>

<script>
import OSS from "ali-oss";
export default {
  name: "UploadFile",
  props: {
    maxSize: {
      // 文件大小限制
      type: Number,
    },
  },
  dir: "/home/banner",
  // 该文件是否需要认证才能访问 [PUBLIC  PRIVATE]
  type: "PUBLIC",
  data() {
    return {
      loading: false,
      imgSrc: "",
      showTip: "block",
      // preUrl: process.env.VUE_APP_UPLOAD_FILE_URL,
    };
  },
  methods: {
    onClick() {
      this.$refs.uploadFile.value = "";
      this.$refs.uploadFile.click();
    },
    onUploadSuccees(res) {
      this.$emit("onSucceed", res);
    },
    onChange() {
      if (this.$refs.uploadFile.files[0].size / 1024 / 1024 >= this.maxSize) {
        this.$message.error("上传大小不能超过" + this.maxSize + "M");
        return;
      }
      // this.api.storage.ApplySecurityToken().then(res => {
      // this.$api.support.getOssToken("/", "PUBLIC").then(data => {
      this.$api.storage.ApplySecurityToken().then((res) => {
        let data = res.data;
        const file = this.$refs.uploadFile.files[0];
        let client = new OSS({
          region: data.region,
          //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          stsToken: data.securityToken,
          bucket: data.bucket,
        });
        this.loading = true;
        let fileName = data.dir + "/"  +  (new Date()).getTime() + "/" + file.name;
        client
          .put(fileName, file)
          .then((r1) => {
            r1.url = r1.url.replace("http:", "https:");
            //  r1.url = this.preUrl + '/' + fileName;
            const param = {
              item: r1,
              file: file,
            };
            this.onUploadSuccees(param);
          })
          .catch((err) => {
            console.error("error: %j", err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    uploadFile() {},
  },
};
</script>
<style scoped>
.outer {
  display: inline-block;
  background-color: #fff;
  text-align: center;
  cursor: pointer;
}
input {
  display: none !important;;
}
</style>